<template>
	<div class="beta-features-card">
		<div class="beta-features-card__content">
			<span class="beta-features-card__name">
				{{ source.description }}
			</span>
		</div>
		<ActionsSet
			class="beta-features-card__actions"
			:id="`${uid}_action`"
			:variant="variant"
			:options="actions"
		/>
	</div>
</template>

<script>
import ActionsSet from '@/site-components/actions-set/actions-set';
import { MODULE_NAME } from '../beta-features-mutation-types';

export default {
	name: 'BetaFeaturesCard',
	props: {
		source: {
			type: Object,
			default: () => {}
		}
	},
	components: {
		ActionsSet
	},
	computed: {
		actions() {
			let items = [];
			if (this.hasSettingPermissions) {
				items.push({
					id: 1,
					action: {
						name: `${MODULE_NAME}-edit`,
						params: {
							id: this.source.id
						}
					},
					title: 'Select to go to beta feature settings',
					iconClass: 'icon icon-manage',
					label: 'Settings',
					type: 'route-link',
					visible: true,
					disabled: !this.validatePermission('features.update')
				});
			}
			items.push({
				id: 2,
				action: {
					path: `/features/${this.source.id}/history`
				},
				iconClass: 'icon icon-history',
				label: 'History',
				title: 'Select to go to feature history',
				type: 'route-link',
				visible: true
			});

			return items;
		},
		hasSettingPermissions() {
			return this.validatePermission([
				'features.create',
				'features.update'
			]);
		}
	},
	methods: {
		showModal() {
			this.$emit('showCompanies', this.source);
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Beta Features Card
	* Can use SCSS variables = TRUE
 */

@import '@/scss/5-objects/_cards.scss';

.beta-features-card {
	@include card;
	display: grid;
	gap: $gutter-md;

	&__name {
		@include heading('md');
		text-transform: capitalize;
		word-break: break-word;
	}

	@include mq($from: md) {
		grid-template-columns: auto auto;
	}
}
</style>
